import { ReactComponent as Help } from '@public/icons/help.svg';
import Icon from '../atoms/Icon';

const IconHelp = (props) => <Icon as={Help} {...props} />;

IconHelp.propTypes = Icon.propTypes;

export default IconHelp;
